import { useAuth } from '@/api';
import { Dashboard } from '@/common/components/Dashboard';
import { GlfhLanding } from '@/common/components/Prelogin';

const LandingPage = () => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return <Dashboard />;
  }

  return <GlfhLanding />;
};

export default LandingPage;
